var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-list-item",
        { attrs: { disabled: _vm.disabled } },
        [
          _c(
            "v-list-item-title",
            [
              _vm.icon
                ? _c("font-awesome-icon", { attrs: { icon: _vm.icon } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  class: _vm.classes,
                  attrs: {
                    href: _vm.link,
                    disabled: _vm.disabled,
                    alt: _vm.label,
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }